import { BsTelephone } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import { MdDeliveryDining, MdOutlineCancel } from "react-icons/md";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { RiProgress2Fill } from "react-icons/ri";
import { SlCheck } from "react-icons/sl";
import { useSelector } from "react-redux";
import moment from "moment";
import "../../../../Assets/css/tailwind.css";
import { formattedAmount } from "../../../../utils/helpers/Functions.helper";
import DropdownMenubar from "../../../../Components/Menubar/DropdownMenubar";
import { Badge } from "primereact/badge";
import { toast } from "react-toastify";
import OrderApi from "../../../../App/api/order.apis";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FcShop } from "react-icons/fc";
import PrintInvoice from "./PrintInvoice";


function OrderDetails({ deliveryAddress,OrderDataFun, orderDetails,handleCloseOrderModal, orderData }) {
  const { theme } = useSelector((state) => state.theme);
  console.log("orderDetails:",orderDetails)
  const handleAction=async(data, action)=>{

    if (action.vendor_action) {
      const payload={
        orderId:data._id,
        vendor_action:action.vendor_action
      }
      try {
      const res = await  OrderApi.updateOrders(payload)  
      toast.success(`${res?.data?.data}`)
      handleCloseOrderModal();
      OrderDataFun();
      
      } catch (error) {
        console.log(error);
        
      }
    }
    
  }

  
  
  // Check if delivery address and order details exist
  // console.log("address details", deliveryAddress);
  // console.log("order details", orderDetails);
  // if (
  //   !deliveryAddress ||
  //   !Array.isArray(orderDetails) ||
  //   orderDetails.length === 0
  // ) {
  //   return (
  //     <div className="w-full h-full flex justify-center items-center">
  //       <h1 className="text-lg font-semibold">No details available</h1>
  //     </div>
  //   );
  // }

  return (
    <div
      className={`p-6 mx-auto rounded-lg shadow-md transition-all duration-300 ease-in-out ${
        theme === "light"
          ? "bg-white text-gray-800"
          : "bg-darkThirsary text-darkSecondary"
      }`}
    >
      <div className="mb-6 border-b border-gray-300 pb-4">
        <div className="flex justify-between items-center">
          <div>
            <p className="text-sm font-medium">
              Invoice #{orderData?.order_id} -{" "}
              {moment(deliveryAddress?.createdAt).format("DD MMM YYYY hh:mm A")}
            </p>
            <p>
              Payment status:{" "}
              <span
                className={`text-sm ${
                  orderData?.payment_status === "UNPAID"
                    ? "text-red-500"
                    : "text-green-500"
                }`}
              >
                {orderData?.payment_status}
              </span>
            </p>

            <p className="text-sm text-gray-500">
              Payment type {orderData?.pay_type}
            </p>
          </div>
          <div className="bg-blue-900 text-white px-4 py-2 rounded-md text-sm text-center shadow">
            <p>{orderData?.delivery_status}</p>
            <p>
              {moment(deliveryAddress?.updatedAt).format("DD MMM YYYY hh:mm A")}
            </p>
          </div>
        </div>
      </div>

      <div className="mb-6">
        <h3 className="font-semibold mb-2 text-lg">Order by</h3>
        <p className="text-xl font-semibold hover:text-blue-900 transition duration-300">
          {deliveryAddress?.name ?? "N/A"}
        </p>
        <div className="flex justify-between items-center mt-1">
          <p className="text-gray-500 text-xl hover:text-blue-900 transition duration-300">
            {deliveryAddress?.phone_number ?? "N/A"}
          </p>
          <BsTelephone className="text-2xl text-blue-900 hover:text-blue-700 transition duration-300" />
        </div>

        <div className="flex items-center p-2 gap-4 mt-4 bg-gray-100 rounded-lg shadow-sm">
          <CiLocationOn className="text-3xl text-blue-900" />
          <p className="text-gray-700">
            {deliveryAddress?.flat_no ?? "N/A"},{" "}
            {deliveryAddress?.landmark ?? "N/A"},
            {deliveryAddress?.street ?? "N/A"},{" "}
            {deliveryAddress?.pin_code ?? "N/A"}
          </p>
        </div>
        {/* <p className="text-gray-500 text-sm mt-2">2.90 Km, 8.75 Min</p>
        <p className="text-gray-700 mt-3 font-medium">Order for</p> */}
        {/* <p className="text-gray-700 mt-4 text-xl hover:text-blue-900 transition duration-300">
          {deliveryAddress?.name ?? "N/A"}
        </p> */}
      </div>
      <div
        className={`p-6 rounded-lg shadow-lg max-w-lg mx-auto transition-all duration-300 ${
          theme === "light"
            ? "bg-secondaryColor text-textColorLight"
            : "bg-darkThirsary text-darkSecondary"
        }`}
      ></div>
      <hr className="my-4 border-gray-300" />

      
    {orderDetails.map((details, index) => (
  <div
    key={index}
    className="mb-6 p-5 bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100"
  >
    {/* 🔵 Delivery Partner */}
    {details?.assigned_delivery_personnel && (
      <div className="mb-4 p-4 bg-blue-50 rounded-lg">
        <h4 className="text-sm font-semibold text-blue-900 mb-2">
          Delivery Partner
        </h4>

        <div className="flex justify-between items-start">
          <div>
            <p className="text-base font-semibold text-gray-900">
              {details.assigned_delivery_personnel.firstName}{" "}
              {details.assigned_delivery_personnel.lastName}
            </p>

            <p className="text-sm text-gray-700 mt-1">
              📞 {details.assigned_delivery_personnel.phoneNumber}
            </p>

            {details.assigned_delivery_personnel.alternatePhoneNumber && (
              <p className="text-xs text-gray-500">
                Alt: {details.assigned_delivery_personnel.alternatePhoneNumber}
              </p>
            )}
          </div>

          <div className="text-xs text-gray-600 text-right">
            <p>
              <span className="font-medium text-gray-700">Vehicle:</span>{" "}
              {details.assigned_delivery_personnel.vehicleType}
            </p>
            <p>
              <span className="font-medium text-gray-700">Status:</span>{" "}
              {details.assigned_delivery_personnel.availability?.status}
            </p>
          </div>
        </div>
      </div>
    )}

    {/* 🟡 Vendor Section */}
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-3">
        {details?.vendor?.profile_image ? (
          <LazyLoadImage
            src={details.vendor.profile_image}
            alt="vendor"
            className="w-14 h-14 rounded-lg object-cover"
          />
        ) : (
          <div className="w-14 h-14 bg-gray-200 rounded-lg flex items-center justify-center">
            <FcShop className="text-3xl text-gray-400" />
          </div>
        )}

        <h3 className="text-lg font-semibold text-gray-800">
          {details?.vendor?.first_name || "Vendor"}
        </h3>
      </div>

      <GetVendorInfo row={details} handleAction={handleAction} />
    </div>

    <hr className="my-4 border-gray-200" />

    {/* 🟢 Product Info */}
    <div>
      <h3 className="text-base font-semibold text-gray-800 mb-2">
        {details?.product?.name ?? "Unnamed Product"}
      </h3>

      <div className="flex justify-between text-sm text-gray-600">
        <span>
          Quantity:{" "}
          <span className="font-medium text-gray-800">
            {details?.quantity ?? 0}
          </span>
        </span>

        <span>
          Price:{" "}
          <span className="font-medium text-gray-800">
            {formattedAmount(
              Number(details?.price?.$numberDecimal ?? 0)
            )}
          </span>
        </span>
      </div>

      <div className="flex justify-between text-sm text-gray-600 mt-1">
        <span>
          Delivery Fee:{" "}
          <span className="font-medium text-gray-800">
            {formattedAmount(
              Number(details?.delivery_fee?.totalDeliveryFee ?? 0)
            )}
          </span>
        </span>
      </div>
    </div>

    {/* 🟣 Total + Status */}
    <div className="flex justify-between items-center mt-4">
      <p className="text-lg font-semibold text-green-600">
        {formattedAmount(
          Number(details?.net_total?.$numberDecimal ?? 0)
        )}
      </p>

      <OrderStatus row={details} />
    </div>

    <hr className="my-3 border-gray-200" />

    {/* 🧾 Invoice */}
    <PrintInvoice
      details={details}
      deliveryDetails={deliveryAddress}
      vendorDetails={details.vendor}
      index={index}
    />
  </div>
))}
    </div>
  );
}

export default OrderDetails;




const OrderStatus=({row}) => {
  let severity;
  if (row.delivery_status === "DELIVERED") {
    severity = "success";
  } else if (row.delivery_status === "WAITING") {
    severity = "warning";
  } else if (row.delivery_status === "ACCEPTED") {
    severity = "success";
  } else if (row.delivery_status === "CANCELLED") {
    severity = "danger";
  }

  return row.delivery_status ? (
    <Badge        
      className="w-[9rem]"
      severity={severity}
      value={row.delivery_status}
    />
  ) : null;
}


const DD = ({MenuItems}) => {
  return (
    <div className="w-[1.5rem] h-[1.5rem] rounded-sm flex justify-center items-center">

      <DropdownMenubar
        menuItem={[
          {
            label: "Action",
            items: MenuItems,
          },
        ]}
        />
    </div>
  );
};
const GetVendorInfo = ({row,handleAction}) => {
  // console.log("Get Status",row);
  
  const status = row?.delivery_status;
  switch (status) {
    case "WAITING":
      return <DD MenuItems={
        [
          {
            label: "ACCEPT",
            icon: <SlCheck style={{color:" rgb(15 61 100)"}} />,
            command: () => {
              // console.log("Accept", row);
              handleAction && handleAction(row,{vendor_action:"ACCEPT"})
            },
          },
          {
            label: "REJECT",
            icon: <MdOutlineCancel style={{color:" rgb(15 61 100)"}}/>,
            command: () => {
              // console.log("Reject", row);
              handleAction&&handleAction(row,{vendor_action:"REJECT"})
            },
          },
        ]
      }/>   
    case "REQUEST_RETURN":      
      return <DD MenuItems={
        [
          {
            label: "ACCEPT return",
            icon: <SlCheck style={{color:" rgb(15 61 100)"}} />,
            command: () => {
              // console.log("Accept", row);
              handleAction && handleAction(row,{vendor_action:"ACCEPT_RETURN"})
            },
          },
          {
            label: "REJECT return",
            icon: <MdOutlineCancel style={{color:" rgb(15 61 100)"}}/>,
            command: () => {
              // console.log("Reject", row);
              handleAction&&handleAction(row,{vendor_action:"REJECT_RETURN"})
            },
          },
        ]
      }/>   
    case "REJECTED":
      return <>Rejected</>;
    case "ACCEPTED":
      return <DD MenuItems={[
        {
          label: "ASSIGN",
          icon: <RiProgress2Fill style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("ASSIGN", row);
            handleAction&&handleAction(row,{vendor_action:"ASSIGN"})
          },
        },
        {
          label: "Delivered",
          icon: <MdDeliveryDining style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("CANCEL");
            handleAction&&handleAction(row,{vendor_action:"DELIVERED"})
          },
        },
        {
          label: "CANCEL",
          icon: <MdOutlineCancel style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("CANCEL", row);
            handleAction&&handleAction(row,{vendor_action:"CANCEL"})
          },
        },
      ]}/>;
    case "PREPARED":
      return <DD MenuItems={[
        {
          label: "READY",
          icon: <IoCheckmarkDoneCircleOutline style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("Accept", row);
            handleAction&&handleAction(row,{vendor_action:"READY"})
          },
        },
        {
          label: "CANCEL",
          icon: <MdOutlineCancel style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("CANCEL", row);
            handleAction&&handleAction(row,{vendor_action:"CANCEL"})
          },
        },
      ]}/>;
    case "READY":
      return <DD MenuItems={[
        {
          label: "ASSIGN",
          icon: <MdDeliveryDining style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("Accept");
            handleAction&&handleAction(row,{vendor_action:"ASSIGN"})
          },
        },
        {
          label: "CANCEL",
          icon: <MdOutlineCancel style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("CANCEL");
            handleAction&&handleAction(row,{vendor_action:"CANCEL"})
          },
        },
      ]}/>;
    case "ASSIGNED":
      return <DD MenuItems={[
        {
          label: "set as DELIVERED",
          icon: <MdDeliveryDining style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("Accept");
            handleAction&&handleAction(row,{vendor_action:'DELIVERED'})
          },
        },
        {
          label: "CANCEL",
          icon: <MdOutlineCancel style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("CANCEL");
            handleAction&&handleAction(row,{vendor_action:'CANCEL'})
          },
        },
      ]}/>;
    default:
      return <></>;
  }
};

